<template>
  <span></span>
</template>

<script>
import setInputValue from "../utils/setInputValue";
const arrayShuffle = (array) => {
  console.log('using Fisher-Yates Shuffle')
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
};

export default {
  props: {
    values: {default: ''},
    saveTo: {default: ''},
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    const saveTo = this.saveTo.split(',').map(v => trim(v));
    const values = this.values.split(',').map(v => trim(v));
    const shuffledValues = arrayShuffle([...values]);
    saveTo.forEach((q, i) => {
      setInputValue(q, shuffledValues[i])
    })
  },
  methods: {},
  watch: {},
  components: {}
}
</script>
